import { render, staticRenderFns } from "./UberEventDetails.vue?vue&type=template&id=24e37169&"
import script from "./UberEventDetails.vue?vue&type=script&lang=js&"
export * from "./UberEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./UberEventDetails.vue?vue&type=style&index=0&id=24e37169&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QBtn,QIcon,QCardSection,QSelect,QToggle,QTable,QTd,QTr,QInput});
